<!-- <div class="container py-2 d-flex justify-content-between">
    <div class="form-check">
        <input class="form-check-input" type="radio" name="flexRadioDefault" (change)="reloadCalendar($event,1)" id="flexRadioDefault1" [checked]="timeChosen==1">
        <label class="form-check-label" for="flexRadioDefault1">
          Mes cours  uniquement
        </label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="radio" name="flexRadioDefault" (change)="reloadCalendar($event,2)" id="flexRadioDefault2" [checked]="timeChosen==2">
        <label class="form-check-label" for="flexRadioDefault2">
          Toute la classe
        </label>
      </div>
</div> -->
<app-simple-calendar [data]="data"></app-simple-calendar>